import { render } from "./ProjectCollections.vue?vue&type=template&id=f72845ea"
import script from "./ProjectCollections.vue?vue&type=script&lang=js"
export * from "./ProjectCollections.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/tools.planval.ch/tools.planval.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__